import { render, staticRenderFns } from "./goodsContent.vue?vue&type=template&id=acc24828"
import script from "./goodsContent.vue?vue&type=script&lang=js"
export * from "./goodsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports